import { MaterialMasterPage } from "./material-master-page"

// Who physically moved a consignment. Recorded on a Material Issue Note when
// the material is transported rather than picked up, so something in transit
// can be chased by LR number.
export default function TransportersPage() {
  return (
    <MaterialMasterPage
      config={{
        title: "Transporters",
        endpoint: "transporters",
        resource: "MaterialTransporter",
        primaryLabel: "transporter_name",
        columns: [
          { key: "transporter_code", label: "Code" },
          { key: "transporter_name", label: "Name" },
          { key: "contact_person", label: "Contact" },
          { key: "contact_number", label: "Phone" },
          { key: "gst_number", label: "GST" },
          { key: "is_active", label: "Active" },
        ],
        fields: [
          { name: "transporter_name", label: "Transporter Name", type: "text" },
          { name: "contact_person", label: "Contact Person", type: "text" },
          { name: "contact_number", label: "Contact Number", type: "text" },
          { name: "email", label: "Email", type: "text" },
          { name: "address", label: "Address", type: "textarea" },
          { name: "gst_number", label: "GST Number", type: "text" },
          { name: "remarks", label: "Remarks", type: "textarea" },
          { name: "is_active", label: "Active", type: "checkbox" },
        ],
      }}
    />
  )
}
